import { useEffect, useState } from "react";

export function LastUpdate() {
  const [label, setLabel] = useState<string | null>(null);

  useEffect(() => {
    const timestamp = Date.now();
    fetch(`/last-update.json?t=${timestamp}`, { cache: "no-cache" })
      .then((res) => (res.ok ? res.json() : null))
      .then((data: { date?: string } | null) => {
        if (!data?.date) return;
        const date = new Date(data.date);
        if (Number.isNaN(date.getTime())) return;
        const day = String(date.getDate()).padStart(2, "0");
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const year = date.getFullYear();
        const time = date.toLocaleTimeString("he-IL", {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
        setLabel(`${day}/${month}/${year}, ${time}`);
      })
      .catch(() => {
        /* optional asset */
      });
  }, []);

  if (!label) return null;
  return (
    <div className="last-update" aria-live="polite">
      עדכון אחרון באתר: {label}
    </div>
  );
}
